import React, { useState, useEffect, useContext } from 'react';
import Banner from '../component/Common/Banner'
import { AuthContext } from '../context/AuthContext';
import API from '../utils/api';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import giftcard from '../assets/img/common/giftcard.png'
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import * as actions from "../actions/giftcard";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useHistory } from "react-router-dom"
import CheckoutOne from './checkout';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';

const Giftcards = (props) => {
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const isAuthentic = isAuthenticated()
    const [step, setStep] = useState(12)
    const [loading, setLoading] = useState(false);
    const [stripeOptions, setStripeOptions] = useState({});
    const [orderID, setOrderID] = useState(uuidv4());
    const [show, setShow] = useState(false);
    const [chosenGiftcard, setChosenGiftcard] = useState({});
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [amount, setAmount] = useState(200);
    const [message, setMessage] = useState('');
    const [order, setorder] = useState({});


    useEffect(() => {
        props.fetchGiftcards()
    }, []);

    const handleClose = () => {
        setShow(false)

    };
    const handleShow = (id) => {
        if (!isAuthentic) {
            history.push('/login')
            return
        }
        setChosenGiftcard(id)
        setName('')
        setEmail('')
        setMobile('')
        setAmount(200)
        setStep(12)
        setMessage('')
        setShow(true);
    }


    const getReferenceToken = async () => {

        setLoading(true);
        let param = {
            amount: amount,
            currency: 'AED',
            metadata: {
                'name': authUser.firstName + ' ' + authUser.lastName,
                'email': authUser.email,
                'mobile': authUser.mobile,
                'OrderID': orderID
            }
        }


        API.utility().createPaymentIntent(param)
            .then(async (res) => {

                // console.log(res.data, 'ooo', res?.data?.split('pi_').pop().split('_secret')[0])
                setOrderID(res?.data?.split('pi_').pop().split('_secret')[0])
                let options = {
                    clientSecret: res.data
                }
                setStripeOptions(options)
                setLoading(false);

                setStep(13)

                //  await initializePaymentSheet(res.data,res?.data?.split('pi_').pop().split('_secret')[0]);
            })
            .catch(err => console.log(err))


    };

    const paymentStatus = (isSuccess, result) => {
        setLoading(true);
       
        if (isSuccess) {
            API.giftcardorder().create({
                name: name,
                email: email,
                mobile: mobile,
                message: message,
                sender: authUser.id,
                amount: amount,
                giftcard: chosenGiftcard.id,
                expiry: chosenGiftcard?.expiry ? chosenGiftcard?.expiry : 30,
                transactionNumber: orderID,
            })
                .then(response => {

                    if (response.data) {
                        setLoading(false);
                        setorder(response.data)
                        setStep(14)
                    }
                })
        }

    }

    return (
        <>

            <section id="giftbanner">
                <div className="container ">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 text-lg-right text-center">
                            <h3 className='font-weight-lighter text-capitalize '>ADAM & EVE</h3>
                            <span className="display-4 mt-4 sofia text-danger font-italic text-golden">{t('giftcards')}</span>

                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 text-left d-none d-lg-block">
                            <img src={giftcard} className='ml-5' style={{ height: 100 }} />

                        </div>
                    </div>
                </div>
            </section>
            <div className='container py-5'>
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-12 product_details_tabs mb-4'>
                        <ul className="nav nav-tabs nav nav-tabs px-3 py-2 justify-content-between">
                            <li><a data-toggle="tab" href="#tab1" className="active">{t('egiftcards')}</a></li>
                            <li><a data-toggle="tab" href="#tab2">{t('forcorp')}</a></li>
                            <li><a data-toggle="tab" href="#tab3">{t('howto')}</a></li>
                            <li><a data-toggle="tab" href="#tab4">{t('termsandconditions')}</a></li>
                        </ul>
                    </div>
                    <div className="tab-content">
                        <div className="tab-pane fade show active" id="tab1">
                            <div className='text-center mb-3'>
                                <h4>{t('choosedesign')}</h4>
                                <p>{t('sendgifttoloved')}</p>
                            </div>
                            <div className="row">

                                {props.giftcards.map((data, index) => (
                                    <div className="col-lg-4 mb-1" key={index}>
                                        <div className="team_slider">


                                            <div className="team-single">
                                                <div className="team-img">
                                                    <img src={process.env.REACT_APP_IMG_URL + data.image} className="depImg" />
                                                </div>
                                                <div className="team-content pt-2" style={{ background: '#f7f3f0' }}>
                                                    <h3 className='mb-1'>{data.title[i18n.language]}</h3>
                                                    <p className='small text-body lines'>{data.description[i18n.language]}</p>
                                                    <button className="btn mt-1 btnprofile btn-block border-radius-0 bg-golden" onClick={() => handleShow(data)}>{t('send')} <IoIosArrowRoundForward size={40} /></button>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="tab-pane fade show " id="tab2">

                        </div>
                        <div className="tab-pane fade " id="tab3">

                        </div>
                        <div className="tab-pane fade" id="tab4">

                        </div>
                    </div>
                </div>
            </div>


            <Modal size="lg" show={show} onHide={handleClose} centered>
                {/* <Modal.Header closeButton>
                    <Modal.Title className='m-auto'>Send Gift Card</Modal.Title>
                </Modal.Header> */}
                <Modal.Body>
                    <div className='row border-bottom mb-30'>
                        <div className='col-md-12 col-12'>
                            <div className="md-stepper-horizontal orange">
                                <div className={`md-step ${step === 11 ? "active" : ""}` + `${step > 11 ? " done" : ""}`}>
                                    <div className="md-step-circle"><span>1</span></div>
                                    <div className="md-step-title">{t('choosedesign')}</div>
                                    <div className="md-step-optional"></div>
                                    <div className="md-step-bar-left"></div>
                                    <div className="md-step-bar-right"></div>
                                </div>
                                <div className={`md-step ${step === 12 ? "active" : ""}` + `${step > 12 ? " done" : ""}`}>
                                    <div className="md-step-circle"><span>2</span></div>
                                    <div className="md-step-title">{t('rcvrdetails')}</div>
                                    <div className="md-step-optional"></div>
                                    <div className="md-step-bar-left"></div>
                                    <div className="md-step-bar-right"></div>
                                </div>
                                <div className={`md-step ${step === 13 ? "active" : ""}` + `${step > 13 ? " done" : ""}`}>
                                    <div className="md-step-circle"><span>3</span></div>
                                    <div className="md-step-title pr-4">{t('payment')}</div>
                                    <div className="md-step-optional"></div>
                                    <div className="md-step-bar-left"></div>
                                    <div className="md-step-bar-right"></div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {step === 12 &&
                        <div className='row'>

                            <div className='col-lg-7'>

                                <form onSubmit={(e) => { e.preventDefault(); getReferenceToken() }}>
                                    <div className="form-group">
                                        <small>{t('rcvrname')}</small>
                                        <input type="text" className="form-control" value={name} required onChange={(e) => setName(e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <small>{t('rcvremail')}</small>
                                        <input type="email" className="form-control" value={email} required onChange={(e) => setEmail(e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <small>{t('rcvrmobile')}</small>
                                        <input type="text" className="form-control" value={mobile} required onChange={(e) => setMobile(e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <small>{t('howmuchgift')}</small>
                                        <input type="number" className="form-control" min="50" max="5000" required value={amount} onChange={(e) => setAmount(e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <small>{t('message')}</small>
                                        <input type="text" className="form-control" value={message} required onChange={(e) => setMessage(e.target.value)} />
                                    </div>
                                    <div className='text-center'>
                                        {loading ?
                                            <button className="btn bg-eve m-auto">{t('processing')}... <div className="spinner-border text-light spinner-border-sm"></div></button>
                                            :
                                            <button type="submit" className="btn bg-eve m-auto">{t('proceedpayment')}</button>
                                        }

                                    </div>

                                </form>





                            </div>



                            <div className='col-lg-5'>
                                <div className="card mt-4" >
                                    <img className="card-img-top" src={process.env.REACT_APP_IMG_URL + chosenGiftcard.image} />
                                    <div className="card-body">
                                        <p className="card-title text-black">Hi, {name}</p>
                                        <p className="card-text small">You have recieved gift card worth AED{amount} from {authUser.firstName}.</p>
                                        <p className="card-text small">{message}</p>
                                        <p className="card-text small">Gift Card ID: **** **** **** ****</p>
                                    </div>
                                </div>
                            </div>



                        </div>}

                    {step === 13 &&
                        <CheckoutOne stripeOptions={stripeOptions} paymentStatus={paymentStatus} />
                    }

                    {step === 14 &&

                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="text-center order_complete">
                                    <i className="fa fa-check-circle"></i>
                                    <div className="order_complete_heading">
                                        <h4>#{order.orderno} {t('ordercompleted')}</h4>
                                    </div>
                                    <p>{t('giftcardthankyoumsg')}</p>
                                    <Link onClick={handleClose} className="btn btn-lg bg-adam">Close</Link>
                                </div>
                            </div>
                        </div>

                    }
                </Modal.Body>

            </Modal>

        </>
    )
}


const mapStateToProps = state => ({
    giftcards: state?.giftcard?.giftcards,
})

const mapActionToProps = {


    fetchGiftcards: actions.fetchAll,

}

export default connect(mapStateToProps, mapActionToProps)(Giftcards);

